module.exports = __webpack_public_path__ + "static/media/groups-button.308a0fe3.png";